<template>
<v-container max-width="800">
    <v-card class="pa-2 align-center justify-center">
        <v-card-title>Settings</v-card-title>

        <v-form ref="preferencesForm" lazy-validation>
        <v-layout cols="12" md12 lg8 offset-lg2 xl6 offset-xl3 row>
            <!-- <v-flex xs12 sm6 lg4>
            <v-card class="mx-5 my-4 pa-4">
                <v-card-title>Unit of Measure:</v-card-title>
                <v-card-text>

                <v-select
                    :items="units"
                    v-model="metric"
                    item-text="name"
                    item-value="value"
                />
                </v-card-text>
            </v-card>
            </v-flex> -->
            <v-flex xs12 sm12 lg12>
                <!-- <v-card-title>
                Notifications
                </v-card-title>
                <v-card-subtitle>
                {{ user.user.notif_allowed == 1 ? "You are currently subscribed to Competition Notifications" : "You are not currently subscribed to Competition Notifications" }}
                </v-card-subtitle>
                <v-btn @click="allow_notifications">Notification Setting</v-btn> -->
                <!-- <v-card-text>{{ notifKey }}</v-card-text> -->
                <v-card-text><NotificationPage/></v-card-text>
            </v-flex>
            <v-spacer />
            <v-alert v-if="infoMessage !== ''" type="info">
                <span v-html="infoMessage" />
            </v-alert>
        </v-layout>
        <div v-if="user.status >= 7">
            <v-card-text class="px-4">
                <v-card-title class="px-0">Admin Controls</v-card-title>

                <v-row class="align-center">
                    <v-col cols="12" >
                        <div class="px-0 text-title-large">Download Image Data</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-date-input v-model="rangeImage" label="Select Range" multiple="range" variant="solo-filled" @update:modelValue="downloadImageData" hide-details></v-date-input>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex justify-center align-center">
                        <JsonCSV
                            :data="jsonImageData"
                            :name="filenameImage">
                            <v-btn
                                class="rounded-xl white--text px-6" color="#1ac266"
                                :disabled="Object.keys(jsonImageData).length === 0">
                                Download .CSV {{ resultsImage != null ? '(' + resultsImage + ' results)' : '' }}
                            </v-btn>
                        </JsonCSV>
                    </v-col>

                    <v-col cols="12" >
                        <div class="px-0 text-title-large">Download Survey Data</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-date-input v-model="rangeSurvey" label="Select Range" multiple="range" @update:modelValue="downloadSurveyData" hide-details></v-date-input>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex justify-center align-center">
                        <JsonCSV
                            :data="jsonSurveyData"
                            :name="filenameSurvey">
                            <v-btn
                                class="rounded-xl white--text px-6" color="#1ac266"
                                :disabled="Object.keys(jsonSurveyData).length === 0">
                                Download .CSV {{ resultsSurvey != null ? '(' + resultsSurvey + ' results)' : '' }}
                            </v-btn>
                        </JsonCSV>
                    </v-col>
                </v-row>
            </v-card-text>
        </div>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import NotificationPage from './NotificationPage.vue'
import { VDateInput } from 'vuetify/labs/VDateInput'
import JsonCSV from 'vue-json-csv'
import { useMainStore } from '@/store/store';
import { mapState, mapWritableState } from 'pinia';
import { toRaw, nextTick } from "vue";

// import axios from 'axios'
// import { VDateInput } from 'vuetify/labs/VDateInput'
// import JsonCSV from 'vue-json-csv'
// import { mainStore } from '../store.js '
// const store = mainStore();

export default {
    setup() {
        const store = useMainStore()
        
        // function setAccess(value){
        //   userAccessLevel.value = value
        // }

        return { 
            store,
        }
    },
    name: 'SettingsPage',

    components: {
        NotificationPage,
        VDateInput,
        JsonCSV,

    },
    computed: {
        ...mapState(useMainStore, {
            user: store => store.user,
            isLoggedIn: store => store.isLoggedIn,
        }),
        ...mapWritableState(useMainStore, {

        }),
    },

    data: () => ({
        errorMessage: '',
        infoMessage: '',
        toRawUser: [],

        rangeImage: null,
        jsonImageData: [],
        filenameImage: "",
        resultsImage: null,

        rangeSurvey: null,
        jsonSurveyData: [],
        filenameSurvey: "",
        resultsSurvey: null,
    }),

    methods: {
        convertTier(tier) {
            switch(tier) {
                case "0":
                    return "Absent"
                case "1":
                    return "Subdued"
                case "2":
                    return "Engaging"
                case "3":
                    return "Vivid"
                case "4":
                    return "Brilliant"
            }
        },
        downloadImageData() {
            this.jsonImageData = []
            this.resultsImage = null
            let startDateImage = this.rangeImage[0].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            let endDateImage = this.rangeImage[this.rangeImage.length-1].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            this.filenameImage = "ImageData - " + startDateImage + " to " + endDateImage + ".csv"
            
            let data = {
                startDate: startDateImage,
                endDate: endDateImage,
            }

            axios.post('image_data', data)
            .then((resp) => {
                if (resp.data != null) {
                    this.jsonImageData = JSON.parse(JSON.stringify(resp.data))

                    // Convert numerical value of tier
                    for (var i = 0; i < this.jsonImageData.length; i++) { this.jsonImageData[i].tier = this.convertTier(this.jsonImageData[i].tier) }

                    this.resultsImage = resp.data.length
                }
                else {
                    this.resultsImage = 0
                }
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })
        },
        downloadSurveyData() {
            this.jsonSurveyData = []
            this.resultsSurvey = null
            let startDateSurvey = this.rangeSurvey[0].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            let endDateSurvey = this.rangeSurvey[this.rangeSurvey.length-1].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            this.filenameSurvey = "SurveyData - " + startDateSurvey + " to " + endDateSurvey + ".csv"
            
            let data = {
                startDate: startDateSurvey,
                endDate: endDateSurvey,
            }

            axios.post('survey_data', data)
            .then((resp) => {
                if (resp.data != null) {
                    this.jsonSurveyData = JSON.parse(JSON.stringify(resp.data))

                    // Convert numerical value of tier
                    for (var i = 0; i < this.jsonSurveyData.length; i++) { this.jsonSurveyData[i].tier = this.convertTier(this.jsonSurveyData[i].tier) }

                    this.resultsSurvey = resp.data.length
                }
                else {
                    this.resultsSurvey= 0
                }
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })
        },
    },
    async mounted(){
        // check the user account to see if notifications are allowed and set that value
        this.toRawUser = toRaw(this.user)
        await nextTick()
        // // this.notif_allowed = this.toRawUser.notif_allowed

        // console.log(this.toRawUser)
    },
}
</script>

<style scoped>
.v-btn--disabled {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: rgba(255, 255, 255, 0.3) !important;
}
</style>
